import type { CoverLetterDocumentType } from '@xing-com/crate-lebenslauf-shared-client-document-variable';

import type { AddProfessionalDescriptionField } from '../types/SharedActions';
import { updateLocalStorage } from './updateLocalStorage';

export const addProfessionalDescriptionField = (
  doc: CoverLetterDocumentType,
  value: AddProfessionalDescriptionField['value']
): void => {
  const professionalExperienceDoc = doc.professionalExperience ?? [];

  const experienceToUpdate = professionalExperienceDoc[value];

  if (!experienceToUpdate) return;

  const descriptions = experienceToUpdate.descriptions || [];

  experienceToUpdate.descriptions = [...descriptions, { description: '' }];

  updateLocalStorage(`professionalExperience`, professionalExperienceDoc);
};
